import { useTranslation } from 'react-i18next'
import { useLoaderData, useNavigate } from 'react-router-dom'

import { StyledActionButton } from '@/components/Buttons.tsx'
import { Spinner } from '@/components/Spinner.tsx'
import { Confirm } from '@/components/templates/Confirm.tsx'
import { FormStyled, FormSubmit } from '@/components/templates/Form.tsx'
import {
  FullScreenContainer,
  ScrollableContent,
} from '@/components/templates/ScreenLayout.tsx'
import { ScreenWrapper } from '@/components/templates/ScreenWrapper.tsx'
import { Description, Header1 } from '@/components/Text.tsx'
import { useTrackFormProgress } from '@/hooks/useTrackFormProgress.ts'
import { XpertFormStep } from '@/utils/XpertFormSteps.ts'

import { LoaderData } from './actions.ts'

const ProposedAppointment = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'proposedAppointment',
  })
  const navigate = useNavigate()
  const { error, loadTime, slot } = useLoaderData() as LoaderData
  const { trackFormInteraction } = useTrackFormProgress(
    XpertFormStep.ProposedAppointment,
    { loadTime },
  )

  if (!slot) {
    return (
      <ScreenWrapper>
        <FullScreenContainer>
          <Header1>{t('header')}</Header1>
          <Description>{error ? t('error') : <Spinner />}</Description>
        </FullScreenContainer>
      </ScreenWrapper>
    )
  }

  return (
    <ScreenWrapper>
      <FormStyled method="post">
        <Header1>{t('header')}</Header1>
        <Description>{t('description')}</Description>

        <ScrollableContent>
          <Confirm slot={slot} />
        </ScrollableContent>

        <FormSubmit>
          <StyledActionButton
            variant="Primary"
            type="submit"
            onClick={() => {
              trackFormInteraction({
                action: 'next',
                formFieldName: 'submit',
              })
            }}
          >
            {t('actions.confirmAppointment')}
          </StyledActionButton>

          <StyledActionButton
            variant="Secondary"
            onClick={(e) => {
              trackFormInteraction({
                action: 'next',
                formFieldName: 'select-time-slot',
              })
              e.preventDefault()
              navigate('/referral/automatic-booking')
            }}
            id="select-time-slot"
          >
            {t('actions.selectTimeSlot')}
          </StyledActionButton>
        </FormSubmit>
      </FormStyled>
    </ScreenWrapper>
  )
}

export { ProposedAppointment }
